// extracted by mini-css-extract-plugin
export default {"container":"CreateNewPassword_container__+g4tf","formTitle":"CreateNewPassword_formTitle__vDihJ","formBtn":"CreateNewPassword_formBtn__r-TRm"};